import {getRequest,postRequest,requestAuthority} from '@/sealFilter/requestAuthority'
import Cookies from 'js-cookie'
// 登录
let actioncheck=(data)=>postRequest('/userlogin/action/check',data);
let actionphonecheck=(data)=>postRequest('/userlogin/action/checkphonecode',data);
// 查询机构
let actionsearch=(data)=>postRequest('/org/action/search',data);
let collectionretrieval=(data)=>postRequest('/userlogin/action/getDataByPage',data);
// 查询所有省份-对应首页的是地方版出版社
let orgactionsearch=(data)=>postRequest('/userlogin/action/uorglist',data);
// 查询所有省份-对应首页的是地方版出版社
let searchlist=(data)=>postRequest('/org/action/page',data);
export{
  actioncheck,orgactionsearch,actionsearch,searchlist,actionphonecheck,collectionretrieval
}
// 馆藏接口
export function Bookactionsearch (data) {
  return requestAuthority({
    url: '/public/pb/book/checkstatus/action/search',
    method: 'post',
    data: data,
  })
}
// 查询所有省份-对应首页的是地方版出版社
// export function searchlist (data) {
//   return requestAuthority({
//     url: '/org/action/page',
//     method: 'post',
//     params: data
//   })
// }




// WEBPACK FOOTER //
// ./src/api/authority.js